import date from './filters/date'

const GlobalFilters = {
  install(Vue) {
    Vue.filter('date', date)
  }
}

export default GlobalFilters



// WEBPACK FOOTER //
// ./src/plugins/GlobalFilters.js